export var EField;
(function (EField) {
    EField["Code"] = "code";
})(EField || (EField = {}));
